module.exports = __webpack_public_path__ + "img/purchaser.e29adedd.png";